import DateInput from "../../../components/common/inputs/DateInput";

export default function UserCourseEnrollmentsReportsFilter({
  filterDataHandler,
}) {
  return (
    <div className="w-full flex flex-col flex-wrap my-8 gap-6 px-6">
      <div className="admin-filter-grid">
        <DateInput
          label={"از تاریخ"}
          onChange={(e) => filterDataHandler({ page: 1, from: e })}
        />
        <DateInput
          label={"تا تاریخ"}
          onChange={(e) => filterDataHandler({ page: 1, to: e })}
        />
        <label className="flex flex-col gap-2 text-sm dark:text-white">شناسه کاربر
          <input className="admin-field" onChange={(e) => filterDataHandler({ user: e.target.value })} />
        </label>
        <label className="flex flex-col gap-2 text-sm dark:text-white">نوع ثبت‌نام
          <select className="admin-field" onChange={(e) => filterDataHandler({ isAdminRegistration: e.target.value })}>
            <option value="">همه</option><option value="1">ثبت‌نام ادمین</option><option value="0">ثبت‌نام کاربر</option>
          </select>
        </label>
      </div>
    </div>
  );
}
